import { Button } from 'react-bootstrap';
import { useHistory } from 'react-router-dom';
import cartaGlobo from 'assets/img/carta_globo.png';
import cartaCorazon from 'assets/img/carta_corazon.png';
import styles from './styles.module.scss';
import { useWindowSize } from 'hooks';

const Flujo = ({ typeId }) => {
  const [, { isMobile }] = useWindowSize();
  const history = useHistory();

  const handleCreateInvitation = () => {
    history.push('/agrega-invitados-excel/' + typeId);
  };

  const handleCreateMyThankYouCard = () => {
    alert('Flujo agradecimientos');
  };

  return (
    <>
    {!isMobile ? (
      <div style={{ marginTop: '200px' }} className="container">
        <div className="row">
          <div className="col-md-5 border rounded text-justify p-md-4">
            <br />
            <b>Confirmación de invitados</b><br /><br />
            Crea y envía por correo electrónico la<br />invitación y confirmación de<br />asistencia a tus invitados.<br /><br />
            <center><img src={cartaGlobo} alt="Carta Globo" /></center><br />
            <Button
              id={1}
              block
              variant="primary"
              onClick={handleCreateInvitation}
              type="button"
              className={''}>
              Crear mi invitación
            </Button>
            <br />
          </div>
          <div className="col-md-2"></div>
          <div className="col-md-5 border rounded text-justify p-md-4">
            <br />
            <b>Agradecimientos</b><br /><br />
            Envía a tus invitados una tarjeta de<br />agradecimiento<br /><br />
            <center><img src={cartaCorazon} alt="Carta Corazón" /></center><br /><br />
            <Button
              id={2}
              block
              variant="primary"
              onClick={handleCreateMyThankYouCard}
              type="button"
              className={''}>
              Crear mi tarjeta de agradecimiento
            </Button>
            <br />
          </div><br />
        </div>
        <br /><br />
      </div>
    ):(
      <div className={styles.containerMobile}>
        <div className="row">
          <div className={`border rounded ${styles.containerCardMobile} my-2`} onClick={handleCreateInvitation}>
            <div className={`${styles.containerImageMobile} ${styles.containerImageBalloon}`}>
              <img src={cartaGlobo} alt="Carta Globo" />
            </div>
            <div className={` ${styles.containerCenterMobile}`}>
              <b>Confirmación de invitados</b> <br />
              Crea y envía por correo electrónico la invitación y confirmación de asistencia a tus invitados.
            </div>
            <div className={styles.angleRight}><i className="fa fa-angle-right" type="button" aria-hidden="true" /></div>
          </div>
          
          <div className={`border rounded ${styles.containerCardMobile} my-2`} onClick={handleCreateMyThankYouCard}>
            <div className={`${styles.containerImageMobile} ${styles.containerImageHeart}`}>
              <img src={cartaCorazon} alt="Carta Corazón" />
            </div>
            <div className={` ${styles.containerCenterMobile}`}>
              <b>Agradecimientos</b> <br />
              Envía a tus invitados una tarjeta de agradecimiento.
            </div>
            <div className={styles.angleRight}><i className="fa fa-angle-right" type="button" aria-hidden="true" /></div>
          </div>
        </div>
      </div>
    )}
    </>

  );
};

export default Flujo;
